import { CartLinesUpdateEvent } from '@shopify/events';

class HmCartUpsell extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick = async (event) => {
    const button = event.target.closest('[data-hm-add]');
    if (!button || !this.contains(button) || button.disabled) return;

    const variantId = Number(button.dataset.variantId);
    if (!variantId) return;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    const cartComponents = Array.from(document.querySelectorAll('cart-items-component'));
    const sectionIds = [
      ...new Set(
        cartComponents
          .map((component) => component.dataset.sectionId)
          .filter(Boolean)
      ),
    ];

    const updatePromise = CartLinesUpdateEvent.createPromise();

    this.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'cart-upsell',
        lines: [{ merchandiseId: String(variantId), quantity: 1 }],
        promise: updatePromise.promise,
      })
    );

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: sectionIds.join(','),
          sections_url: window.location.pathname,
        }),
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'Unable to add this item');

      button.dataset.added = 'true';

      updatePromise.resolve({
        detail: {
          items: data.items,
          sections: data.sections,
          source: 'hm-cart-upsell',
          didError: false,
        },
      });
    } catch (error) {
      console.error('[Happy Mess cart upsell]', error);
      updatePromise.reject(error);
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  };
}

if (!customElements.get('hm-cart-upsell')) {
  customElements.define('hm-cart-upsell', HmCartUpsell);
}
